var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-dialog",
    { ref: "base", attrs: { "max-width": "600" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(" Публикация "),
            _vm.current_client.provider === "vk-oauth2"
              ? _c(
                  "span",
                  { staticClass: "ml-2", staticStyle: { color: "#4a76a8" } },
                  [_vm._v("ВКОНТАКТЕ")]
                )
              : _c(
                  "span",
                  { staticClass: "ml-2", staticStyle: { color: "#ee8208" } },
                  [_vm._v("ОДНОКЛАССНИКИ")]
                ),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { justify: "center", align: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "text-center",
                      staticStyle: { "max-width": "224px" },
                    },
                    [
                      _c("v-img", {
                        staticStyle: {
                          cursor: "pointer",
                          "max-width": "200px",
                        },
                        attrs: { src: _vm.collection.image_url },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticStyle: { "min-width": "250px" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          "no-resize": "",
                          label: "Описание",
                          outlined: "",
                          "hide-details": "",
                          rows: "5",
                        },
                        model: {
                          value: _vm.options.comment,
                          callback: function ($$v) {
                            _vm.$set(_vm.options, "comment", $$v)
                          },
                          expression: "options.comment",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-radio-group",
                {
                  staticClass: "mt-0",
                  attrs: { "hide-details": "", label: "Место публикации:" },
                  on: { change: _vm.onChangePlace },
                  model: {
                    value: _vm.options.place,
                    callback: function ($$v) {
                      _vm.$set(_vm.options, "place", $$v)
                    },
                    expression: "options.place",
                  },
                },
                [
                  _c("v-radio", {
                    attrs: { value: "wall", label: "На своей стене" },
                  }),
                  _c("v-radio", {
                    attrs: { value: "album", label: "В свой альбом" },
                  }),
                  _c("v-radio", {
                    attrs: {
                      value: "group_wall",
                      label: "На стене сообщества",
                    },
                  }),
                  _c("v-radio", {
                    attrs: {
                      value: "group_album",
                      label: "В альбом сообщества",
                    },
                  }),
                ],
                1
              ),
              ["group_wall", "group_album"].includes(_vm.options.place)
                ? _c("v-autocomplete", {
                    staticClass: "mt-4",
                    attrs: {
                      dense: "",
                      "hide-details": "",
                      outlined: "",
                      label: "Сообщество",
                      "no-data-text": "Нет групп",
                      items: _vm.groups,
                      loading: _vm.loading_groups,
                    },
                    on: { change: _vm.onGroupSelect },
                    model: {
                      value: _vm.options.group_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.options, "group_id", $$v)
                      },
                      expression: "options.group_id",
                    },
                  })
                : _vm._e(),
              ["album", "group_album"].includes(_vm.options.place)
                ? _c("v-autocomplete", {
                    staticClass: "mt-4",
                    attrs: {
                      dense: "",
                      "hide-details": "",
                      outlined: "",
                      label: "Альбом",
                      "no-data-text": "Нет альбомов",
                      "item-text": "text",
                      "item-value": "value",
                      items: _vm.albums,
                      loading: _vm.loading_albums,
                    },
                    model: {
                      value: _vm.options.album_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.options, "album_id", $$v)
                      },
                      expression: "options.album_id",
                    },
                  })
                : _vm._e(),
              _c(
                "v-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "v-col",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn mr-2",
                          on: {
                            click: function ($event) {
                              return _vm.$refs.base.hide()
                            },
                          },
                        },
                        [_vm._v("Отмена")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          attrs: {
                            disabled: _vm.disable,
                            loading: _vm.loading_publication,
                            color: "primary",
                          },
                          on: { click: _vm.onPublication },
                        },
                        [_vm._v(" Публикация ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }